import styled from "styled-components";
import { colors } from "../../../../../assets";

export const UrlContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: -30px auto 30px;

  .url-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 5px;
    padding: 5px 10px;
    background-color: ${({ error, info }) =>
      error ? colors["msg-danger"] : info ? colors["msg-info"] : colors["medium-disabled"]};
  }

  a {
    color: blue;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .url-title {
    font-weight: bold;
    white-space: nowrap;
  }

  .url-loading {
    min-width: 200px;
    position: relative;
  }
`;
